module.exports = __webpack_public_path__ + "static/media/youtube.b529aad2.svg";